import { z } from 'zod';
import { DateTimeLocalizationInfo, LocalizedText, validateWithZod, Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { commanderForm } from '@mews-commander/legacy-form';
import { TasksFormFields, TasksFormFieldsProps } from './TasksFormFields';

const taskSchema = ({ dateTimeLocalizationInfo }: { dateTimeLocalizationInfo: DateTimeLocalizationInfo }) =>
    z.object({
        date: Validation.Date.WallClock(dateTimeLocalizationInfo),
        time: Validation.Time.Localized(dateTimeLocalizationInfo),
        name: Validation.String.Required,
    });

const TasksForm = (props: TasksFormFieldsProps) => <TasksFormFields {...props} />;
export default ({ updateTask }: { updateTask: boolean }) =>
    commanderForm({
        submitLabel: <LocalizedText textKey={updateTask ? TextKey.Update : TextKey.Create} />,
        validate: validateWithZod(taskSchema),
        submitButtonProps: { variant: 'primary' },
    })(TasksForm);
